import React from "react";
import { createPortal } from "react-dom";
import {
  CloseIcon,
} from "../../helper/HwIcon";

function WarningPopUp({ show, setShow, children, headerClass,modalClass }) {
  return createPortal(
    <>
      <div className={`hw-modal fade ${show ? "show" : ""}`}>
        <div className={`hw-modal-dialog hw-modal-dialog-centered warning-modal-dialog hw-modal-dialog-scrollable ${modalClass}`}>
          <div className="hw-modal-content">
            <div className="warning-modal-body">{children}</div>
          </div>
        </div>
      </div>
      {show ? <div className="hw-modal-backdrop fade show" /> : ""}
    </>,
    document.body
  );
}

export default WarningPopUp;
